var map = {
	"./temp-persona-1.jpg": 104,
	"./temp-persona-10.jpg": 105,
	"./temp-persona-11.jpg": 106,
	"./temp-persona-12.jpg": 107,
	"./temp-persona-13.jpg": 108,
	"./temp-persona-2.jpg": 109,
	"./temp-persona-3.jpg": 110,
	"./temp-persona-4.jpg": 111,
	"./temp-persona-5.jpg": 112,
	"./temp-persona-6.jpg": 113,
	"./temp-persona-7.jpg": 114,
	"./temp-persona-8.jpg": 115,
	"./temp-persona-9.jpg": 116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;